// Revalidate the cart badge after navigation and successful cart mutations.
(function () {
 if (window.astralCartCountReady) return;
 window.astralCartCountReady = true;
 const originalFetch = window.fetch.bind(window);
 let timer, pending = false, again = false;
 function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 80); }
 async function refresh() {
  if (pending) { again = true; return; } pending = true;
  try {
   const root = window.Shopify?.routes?.root || '/';
   const response = await originalFetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin' });
   if (!response.ok) return;
   const cart = await response.json();
   if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
   document.querySelectorAll('#bag-count').forEach(badge => { badge.textContent = String(cart.item_count); badge.setAttribute('aria-live','polite'); badge.setAttribute('aria-atomic','true'); });
  } catch (_) {} finally { pending = false; if (again) { again = false; schedule(); } }
 }
 function isCartMutation(input, options) {
  try { const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
   const method = String(options?.method || input?.method || 'GET').toUpperCase();
   return method !== 'GET' && url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
  } catch (_) { return false; }
 }
 window.fetch = function(input, options) { const result = originalFetch(input, options); if (isCartMutation(input,options)) result.then(response => { if(response.ok) schedule(); }, () => {}); return result; };
 const originalOpen = XMLHttpRequest.prototype.open, originalSend = XMLHttpRequest.prototype.send;
 const cartRequests = new WeakSet();
 XMLHttpRequest.prototype.open = function(method,url) { cartRequests.delete(this); if(isCartMutation(String(url),{method})) cartRequests.add(this); return originalOpen.apply(this,arguments); };
 XMLHttpRequest.prototype.send = function() { if(cartRequests.has(this)) this.addEventListener('load',()=>{if(this.status>=200&&this.status<300)schedule();},{once:true}); return originalSend.apply(this,arguments); };
 window.addEventListener('pageshow',schedule); window.addEventListener('focus',schedule);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
 ['cart:updated','cart:change','cart:refresh','shopify:section:load'].forEach(name=>document.addEventListener(name,schedule));
 schedule();
})();

// Submit secondary purchase buttons through the same Shopify product form.
(function () {
  const form = document.querySelector('.astral-product-form');
  if (!form) return;
  const mainButton = form.querySelector('[data-product-add]');
  const buttons = Array.from(document.querySelectorAll('[data-benefit-add]'));
  buttons.forEach(function (button) {
    button.removeAttribute('data-benefit-add');
    button.type = 'submit';
    button.setAttribute('form', form.getAttribute('id'));
  });
  function update() {
    const es = document.documentElement.lang.startsWith('es');
    buttons.forEach(function (button) {
      button.disabled = mainButton.disabled;
      button.textContent = (mainButton.disabled ? (es ? 'Agotado' : 'Sold out') : (es ? 'Añadir al carrito' : 'Add to Cart')) + ' ↗';
    });
  }
  update();
  document.addEventListener('variant:change', update);
})();
Object.assign(spanish, {
  "CHOOSE YOUR FLAVOR": "ELIGE TU SABOR",
  "CHOOSE YOUR OPTION": "ELIGE TU OPCIÓN",
  "Purchase options": "Opciones de compra",
  "One-time purchase": "Compra única",
  "Subscribe & save": "Suscríbete y ahorra",
  "SAVE 10%": "AHORRA 10%",
  "Subscribe & save  SAVE 10%": "Suscríbete y ahorra  AHORRA 10%",
  "Deliver every": "Entrega cada",
  "month": "mes",
  "Monthly subscription": "Suscripción mensual",
  "Powered by Seal Subscriptions": "Con tecnología de Seal Subscriptions"
});
translatePage();
setLanguage = function(next) {
  try { localStorage.setItem("astral-language", next); } catch {}
  const target = new URL(location.href);
  const base = target.pathname.replace(/^\/es(?=\/|$)/, "") || "/";
  target.pathname = next === "es" ? "/es" + (base === "/" ? "" : base) : base;
  target.searchParams.delete("lang");
  location.assign(target.href);
};
if (document.documentElement.lang === "es") {
  if (!/^\/es(?:\/|$)/.test(location.pathname)) {
    setLanguage("es");
  } else {
    document.querySelectorAll("a[href]").forEach(link => {
      if (link.getAttribute("href").startsWith("#")) return;
      const target = new URL(link.href, location.href);
      if (target.origin === location.origin && !/^\/es(?:\/|$)/.test(target.pathname)) {
        target.pathname = "/es" + (target.pathname === "/" ? "" : target.pathname);
        link.href = target.href;
      }
    });
  }
}

// Connect story calls to action to Shopify purchase controls.
document.querySelectorAll("[data-benefit-add]").forEach(button => {
  const link = document.createElement("a");
  link.className = button.className;
  link.href = "#purchase";
  link.textContent = document.documentElement.lang === "es" ? "Elegir opciones ↗" : "Choose options ↗";
  button.replaceWith(link);
});
document.querySelectorAll("[data-variant-select]").forEach(select => {
  if (select.options.length === 1 && select.options[0].textContent.trim() === "Default Title") {
    select.hidden = true;
    const label = document.querySelector("label[for=\"" + select.id + "\"]");
    if (label) label.hidden = true;
  }
});
'use strict';
(()=>{
const es=()=>document.documentElement.lang==='es';
const menu=document.querySelector('#menu-toggle'),nav=document.querySelector('#mobile-nav');
menu?.addEventListener('click',()=>{const open=nav.hidden;nav.hidden=!open;menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?'Close menu':'Open menu')});
nav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.hidden=true;menu?.setAttribute('aria-expanded','false')}));
function setup(section){if(section.dataset.initialized)return;section.dataset.initialized='true';
const data=JSON.parse(section.querySelector('[data-variant-data]').textContent),form=section.querySelector('form.astral-product-form'),select=form.querySelector('[data-variant-select]'),plans=form.querySelector('[data-plan-select]'),container=form.querySelector('[data-plan-container]'),price=section.querySelector('[data-product-price]'),compare=section.querySelector('[data-compare-price]'),add=form.querySelector('[data-product-add]'),qty=form.querySelector('[name=quantity]');
const money=cents=>new Intl.NumberFormat(es()?'es-PR':'en-US',{style:'currency',currency:data.currency||'USD'}).format(cents/100);
const current=()=>data.variants.find(v=>String(v.id)===select.value);
function display(){const v=current();if(!v)return;const p=v.plans.find(p=>String(p.id)===plans?.value);price.textContent=money(p?p.price:v.price);compare.hidden=!(v.compare>v.price)&&!p;compare.textContent=money(p?v.price:v.compare);if(p&&p.price===v.price)compare.hidden=true;add.disabled=!v.available||(data.requiresPlan&&!p);add.textContent=!v.available?(es()?'Agotado':'Sold out'):(es()?'Añadir al carrito ↗':'Add to Cart ↗');const desc=form.querySelector('[data-plan-description]');if(desc)desc.textContent=p?.description||'';}
function changeVariant(){const v=current();if(!v)return;if(v.image)section.querySelector('#main-image').src=v.image;qty.min=String(v.min);qty.step=String(v.step);if(v.max)qty.max=String(v.max);else qty.removeAttribute('max');qty.value=String(v.min);if(plans){const previous=plans.value;plans.replaceChildren();if(!data.requiresPlan)plans.add(new Option(es()?'Compra única':'One-time purchase',''));for(const p of v.plans)plans.add(new Option(p.name+' — '+money(p.price),String(p.id)));if(v.plans.some(p=>String(p.id)===previous))plans.value=previous;container.hidden=v.plans.length===0;plans.disabled=v.plans.length===0;}
const url=new URL(location.href);url.searchParams.set('variant',v.id);url.searchParams.delete('selling_plan');history.replaceState(null,'',url);display();select.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant:v}}));}
select.addEventListener('change',changeVariant);plans?.addEventListener('change',display);
form.querySelectorAll('[data-quantity-delta]').forEach(b=>b.addEventListener('click',()=>{const delta=Number(b.dataset.quantityDelta),step=Number(qty.step)||1,min=Number(qty.min)||1,max=Number(qty.max)||Infinity;qty.value=String(Math.max(min,Math.min(max,(Number(qty.value)||min)+delta*step)));qty.dispatchEvent(new Event('change',{bubbles:true}));}));
section.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>{section.querySelector('#main-image').src=b.dataset.image;section.querySelectorAll('[data-image]').forEach(x=>x.classList.toggle('active',x===b));}));
form.addEventListener('submit',e=>{if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}const v=current();if(!v?.available||(data.requiresPlan&&!form.querySelector('[name=selling_plan]')?.value)){e.preventDefault();return;}add.disabled=true;add.textContent=es()?'Añadiendo…':'Adding…';});
if(plans){container.hidden=current().plans.length===0;plans.disabled=current().plans.length===0;}display();}
document.querySelectorAll('[data-product-section]').forEach(setup);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-product-section]').forEach(setup));
window.addEventListener('pageshow',()=>document.querySelectorAll('[data-product-section]').forEach(s=>{const select=s.querySelector('[data-variant-select]');select?.dispatchEvent(new Event('change'));}));
})();
